module.exports = __webpack_public_path__ + "img/product1_3Di-MS2_pc.81783c13.png";